/**
 * Tema de antd 5 a partir de los tokens del sistema (paso 2c de MODERNIZACION).
 *
 * Por qué existe: antd 5 dejó la hoja global y genera sus estilos EN JS, que se
 * inyectan en tiempo de ejecución — es decir, DESPUÉS de nuestras hojas. Con
 * igual especificidad gana el último, así que pelear cada componente a golpe de
 * selector es una carrera perdida (se vio con las pestañas en azul #1677ff y la
 * paginación a 32 px). La vía correcta en antd 5 es decirle nuestros valores y
 * que genere él los estilos.
 *
 * Los valores se repiten aquí como literales a propósito: antd necesita números
 * y colores, no `var(--…)`, porque calcula derivados (hover, activo, sombras) a
 * partir de ellos. La fuente de verdad sigue siendo `styles/tokens.css`; si algo
 * cambia allí, hay que reflejarlo aquí. Esta duplicación es el precio de que
 * antd genere su propia paleta, y desaparecerá con la plantilla.
 */

// Espejo de src/styles/tokens.css
const T = {
  surface: "#ffffff",
  ink: "#101c36",
  ink2: "#5a6376",
  line: "#e2e6ee",
  lineStrong: "#c9d0dc",
  accent: "#ec7137",
  accentText: "#b4501e",
  success: "#0f7a4f",
  danger: "#b42318",
  warning: "#92400e",
  bg: "#f4f6f9",
  radiusBtn: 11,
  radiusInput: 10,
  radiusCard: 12,
  touchMin: 48,
  fontFamily:
    '"Manrope", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
  fontSizeBase: 16,
};

const antdTheme = {
  token: {
    colorPrimary: T.accent,
    colorLink: T.accentText,
    colorLinkHover: T.accent,
    colorSuccess: T.success,
    colorError: T.danger,
    colorWarning: T.warning,
    colorText: T.ink,
    colorTextSecondary: T.ink2,
    colorBorder: T.lineStrong,
    colorSplit: T.line,
    colorBgLayout: T.bg,
    colorBgContainer: T.surface,
    fontFamily: T.fontFamily,
    fontSize: T.fontSizeBase,
    borderRadius: T.radiusInput,
    // Altura de controles = objetivo táctil del brief (§11.3)
    controlHeight: T.touchMin,
  },
  components: {
    // Sobre relleno naranja el texto va NAVY, nunca blanco (regla no negociable
    // del sistema: el blanco sobre #EC7137 da 3,0:1 y falla AA).
    Button: {
      primaryColor: T.ink,
      borderRadius: T.radiusBtn,
      fontWeight: 700,
    },
    Tabs: {
      itemColor: T.ink2,
      itemSelectedColor: T.accentText,
      itemHoverColor: T.accentText,
      inkBarColor: T.accent,
    },
    Pagination: {
      itemSize: 44, // táctil; antd trae 32
      colorText: T.ink,
    },
    Input: { borderRadius: T.radiusInput },
    Select: { borderRadius: T.radiusInput },
    Modal: { borderRadiusLG: T.radiusCard },
    Card: { borderRadiusLG: T.radiusCard },
  },
};

export default antdTheme;
